// @arch:pure-engine
// Project identity is independent of sidebar folders and execution worktrees.
export function importProjectRegistry(previous = {}, sessions = []) {
  if (!previous || typeof previous !== 'object') previous = {};
  const projects = Array.isArray(previous.projects) ? previous.projects.filter((p) => p && typeof p.id === 'string' && typeof p.name === 'string' && typeof p.root === 'string' && p.root.startsWith('/')).map((p) => ({ ...p })) : [];
  const links = Object.fromEntries(Object.entries(previous.links || {}).filter(([, id]) => id === null || projects.some((p) => p.id === id)));
  for (const session of sessions) {
    if (Object.hasOwn(links, session.id)) continue;
    // A worktree path alone cannot establish its source project.
    const root = session.directory;
    if (typeof root !== 'string' || !root.startsWith('/') || root === session.worktree_path) continue;
    const normalized = root.replace(/\/+$/, '') || '/';
    let project = projects.find((p) => p.root === normalized);
    if (!project) {
      project = { id: `project:${encodeURIComponent(normalized)}`, root: normalized, name: normalized.split('/').pop() || normalized };
      projects.push(project);
    }
    links[session.id] = project.id;
  }
  const oldOrder = Array.isArray(previous.order) ? [...new Set(previous.order.filter((id) => typeof id === 'string'))] : [];
  const discovered = sessions.map((s) => s.id).filter((id) => !oldOrder.includes(id));
  return { version: 1, projects, links, order: [...discovered, ...oldOrder] };
}
export function associateProject(storage, scope, registry, sessionId, projectId) {
  if (projectId !== null && !registry.projects.some((p) => p.id === projectId)) return false;
  const next = { ...registry, links: { ...registry.links, [sessionId]: projectId } };
  try { storage.setItem(`apolo:projects:v1:${scope}`, JSON.stringify(next)); return true; }
  catch { return false; }
}
export function loadProjectRegistry(storage, scope, sessions) {
  const key = `apolo:projects:v1:${scope}`;
  let previous = {};
  try { previous = JSON.parse(storage?.getItem(key) || '{}'); } catch { /* import current sessions */ }
  const next = importProjectRegistry(previous, sessions);
  try { storage?.setItem(key, JSON.stringify(next)); } catch { /* keep current projection */ }
  return next;
}

// Environment preference is presentation state, never a permission grant.
export function projectEnvironment(storage, scope, root) {
  if (!root) return 'direct';
  try {
    const value = JSON.parse(storage.getItem(`apolo:project-preferences:v1:${scope}:${encodeURIComponent(root)}`) || '{}');
    return value.environment === 'worktree' ? 'worktree' : 'direct';
  } catch { return 'direct'; }
}
export function saveProjectEnvironment(storage, scope, root, environment) {
  if (!root || !['direct', 'worktree'].includes(environment)) return false;
  try {
    storage.setItem(`apolo:project-preferences:v1:${scope}:${encodeURIComponent(root)}`, JSON.stringify({ environment }));
    return true;
  } catch { return false; }
}
